module.exports = __webpack_public_path__ + "assets/97c23a0e24c0267cbd00903d25179756.png";